<ng-container *transloco="let t">
  <div class="step-container">
    <div class="step-content">
      @if (loading) {
        <!-- Shimmer Loader -->
        <div class="result-shimmer">
          <!-- Icon Shimmer -->
          <div class="shimmer-icon-container"></div>

          <!-- Title Shimmer -->
          <div class="shimmer-title"></div>

          <!-- Description Shimmer -->
          <div class="shimmer-description"></div>

          <!-- Count Box Shimmer -->
          <div class="shimmer-count-box"></div>

          <!-- Info Cards Shimmer -->
          <div class="shimmer-cards">
            @for (item of shimmerItems; track item) {
              <div class="shimmer-card">
                <div class="shimmer-card-icon"></div>
                <div class="shimmer-card-content">
                  <div class="shimmer-card-title"></div>
                  <div class="shimmer-card-text"></div>
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <!-- Actual Content -->
        <!-- Success Icon -->
        <div class="success-icon-container">
          <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
        </div>

        <!-- Title and Description -->
        <h1 class="success-title">{{ t(successTitleKey) }}</h1>
        <p class="success-description">
          {{
            t(successDescriptionKey, {
              partner: partnerName,
              entity: integrationEntityName,
            })
          }}
        </p>

        <!-- Files Count Box -->
        @if (totalFiles > 0) {
          <div class="reports-count-box">
            <span class="count-number">{{ totalFiles }}</span>
            <span class="count-label">
              {{
                totalFiles === 1
                  ? t('lang.success_file')
                  : t('lang.success_files')
              }}
            </span>
          </div>
        }

        <!-- Info Cards -->
        <div class="info-cards">
          <div class="info-card">
            <div class="info-icon check">
              <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
            </div>
            <div class="info-content">
              <h3 class="info-title">{{ t('lang.success_card_1_title') }}</h3>
              <p class="info-text">
                {{
                  t(successCard1DescriptionKey, {
                    partner: partnerName,
                    entity: integrationEntityName,
                  })
                }}
              </p>
            </div>
          </div>

          <div class="info-card">
            <div class="info-icon check">
              <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
            </div>
            <div class="info-content">
              <h3 class="info-title">{{ t('lang.success_card_2_title') }}</h3>
              <p class="info-text">
                {{ t('lang.success_card_2_description') }}
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-container>
